<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="12">
        <section-box v-loading="scholarInterestsLoading">
          <template v-slot:title>
            <p style="font-size: 18px">研究兴趣</p>
          </template>
          <template v-slot:main>
            <div
              style="width: 100%; height: 334px; position: relative"
              v-if="riverData && riverData.legend.length > 0"
            >
              <scholar-interest-chart :data="riverData" />
            </div>
            <div style="height: 334px" v-else>
              <el-empty />
            </div>
          </template>
        </section-box>
        <section-box style="margin-top: 9px" v-loading="scholarTrendLoading">
          <template v-slot:title>
            <p style="font-size: 18px">领域前沿度分析</p>
          </template>
          <template v-slot:main>
            <div
              style="height: 334px; width: 100%; position: relative"
              v-if="
                trendData &&
                trendData.years != null &&
                trendData.years.length > 0
              "
            >
              <scholar-trend :data="trendData" />
            </div>
            <div style="height: 334px" v-else>
              <el-empty />
            </div>
          </template>
        </section-box>
      </el-col>
      <el-col :span="12">
        <section-box v-loading="scholarWordLoading">
          <template v-slot:title>
            <p style="font-size: 18px">研究热词</p>
          </template>
          <template v-slot:main>
            <div
              style="height: 334px; width: 100%; position: relative"
              v-if="hotWordData && hotWordData.length > 0"
            >
              <scholar-hot-word :hot-data="hotWordData" domId="detail" />
            </div>
            <div style="height: 334px" v-else>
              <el-empty />
            </div>
          </template>
        </section-box>
        <section-box style="margin-top: 9px" v-loading="scholarChordLoading">
          <template v-slot:title>
            <p style="font-size: 18px">领域相关度分析</p>
          </template>
          <template v-slot:main>
            <div
              style="height: 334px; width: 100%; position: relative"
              v-if="chordData && chordData.links.length > 0"
            >
              <scholar-chord :data="chordData" />
            </div>
            <div style="height: 334px" v-else>
              <el-empty />
            </div>
          </template>
        </section-box>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ScholarInterestChart from '@/views/details/comps/scholarInterestChart.vue';
import ScholarTrend from '@/views/details/comps/scholarTrend.vue';
import ScholarHotWord from '@/views/details/comps/scholarHotWord.vue';
import ScholarChord from '@/views/details/comps/scholarChord.vue';
import SectionBox from '@/views/details/comps/sectionBox.vue';
import {
  getScholarChordDataApi,
  getScholarInterestsApi,
  getScholarTrendApi,
  getScholarWordApi,
} from '@/api/details';

export default {
  name: 'analysisView',
  components: {
    SectionBox,
    ScholarChord,
    ScholarHotWord,
    ScholarTrend,
    ScholarInterestChart,
  },
  props: ['scholarId', 'fieldTowENames'],
  data() {
    return {
      riverData: null,
      scholarWordLoading: false,
      scholarChordLoading: false,
      scholarInterestsLoading: false,
      scholarTrendLoading: false,
      trendData: {
        data: null,
        years: null,
        legend: null,
      },
      hotWordData: null,
      chordData: {
        nodes: [],
        links: [],
        cats: [],
      },
    };
  },
  created() {
    this.getScholarWord();
    this.getScholarInterests();
    if (this.fieldTowENames.length > 0) {
      let param = '';
      this.fieldTowENames.map((item, index) => {
        if (index < this.fieldTowENames.length) {
          if (index == 0) {
            param = 'fieldNames=' + item.englishName;
          } else {
            param += '&fieldNames=' + item.englishName;
          }
        } else {
          param += '&fieldNames=' + item.englishName;
        }
      });
      this.getScholarChord(param);
      this.getScholarTrend(param);
    }
  },
  methods: {
    /**
     * 领域相关度分析
     * @param param
     */
    getScholarChord(param) {
      this.scholarChordLoading = true;
      getScholarChordDataApi(param).then((res) => {
        this.scholarChordLoading = false;
        if (res.code == 200) {
          let cats = [];
          res.data.nodes.forEach((v) => {
            cats.push(v.name);
          });
          let nodes = [];
          let o = {};
          res.data.links.forEach((v) => {
            o[v.source] = o[v.source] ? o[v.source] + 1 : 1;
            o[v.target] = o[v.target] ? o[v.target] + 1 : 1;
          });
          let count = 0;
          for (let item in o) {
            nodes.push({
              name: item,
              value: o[item],
              symbolSize: o[item] * 10,
              category: count,
              label: {
                normal: {
                  show: o[item] > 0,
                },
              },
            });
            count++;
          }
          this.chordData.nodes = nodes;
          this.chordData.cats = cats;
          this.chordData.links = res.data.links;
        }
      });
    },
    /**
     * 领域前沿度分析
     * @param param
     */
    getScholarTrend(param) {
      this.scholarTrendLoading = true;
      getScholarTrendApi(param).then((res) => {
        this.scholarTrendLoading = false;
        if (res.code == 200) {
          if (Object.keys(res.data).length > 0) {
            this.trendData.data = res.data;
            let years = [];
            let legend = Object.keys(this.trendData.data);
            console.log(legend);
            let year = new Date().getFullYear();
            this.trendData.data[legend[0]].forEach(() => {
              year--;
              years.push(year);
            });
            this.trendData.years = years.reverse();
            this.trendData.legend = legend;
          }
        }
      });
    },
    /**
     * 研究兴趣
     */
    getScholarInterests() {
      this.scholarInterestsLoading = true;
      getScholarInterestsApi(this.scholarId).then((resp) => {
        this.scholarInterestsLoading = false;
        if (resp.code == 200) {
          let res = resp.data;
          if (res.length > 0) {
            let legend = [];
            for (let i in res[0].counts) {
              let tempKey = Object.keys(res[0].counts[i])[0];
              if (!tempKey || tempKey === 'null') tempKey = '未知学科' + i;
              legend.push(tempKey);
            }
            let tempRes = [];
            let currentYear = 0;
            let previousYear = 0;
            let splitIndex = 0;
            let year = new Date().getFullYear();
            for (let i in res) {
              year--;
              currentYear = parseFloat(year);
              // 如果连续20年为空则停止遍历，并去除以保留的20年空白数据
              // 空既为数据为0
              if (currentYear - previousYear <= -20) {
                break;
              }
              let count = 0;
              for (let j in res[i].counts) {
                let tempKey = Object.keys(res[i].counts[j])[0];
                let tempValue = Object.values(res[i].counts[j])[0];
                count += tempValue;
                if (!tempKey || tempKey === 'null') tempKey = legend[j];
                if (!tempValue) tempValue = 0;
                tempRes.push([year, tempValue, tempKey]);
              }
              if (count > 0) {
                previousYear = currentYear;
                splitIndex = i;
              }
            }
            if (splitIndex > 0) {
              let cut = (parseInt(splitIndex) + 1) * res[0].counts.length;
              tempRes.splice(cut);
            }
            this.riverData = {
              data: tempRes,
              legend: legend,
            };
          }
        }
      });
    },
    /**
     * 热词
     */
    getScholarWord() {
      this.scholarWordLoading = true;
      getScholarWordApi(this.scholarId).then((res) => {
        this.scholarWordLoading = false;
        if (res.code == 200) {
          let hotData = [];
          if (res.data.length > 50) {
            hotData = res.data.slice(0, 50);
          } else {
            hotData = res.data;
          }
          this.hotWordData = hotData;
        }
      });
    },
  },
};
</script>

<style scoped></style>
